<template>
    <div class="page-share-land page-wrapper">
        <img src="@divide/assets/images/divide_wchatshare@3x.jpg" alt="" />
        <div class="bottom-btn"></div>
        <QOpenApp class="share-full-page" :api="apiInitWxConfig" :url="openAppParams.url" :jumpToDownloadTime="2000" openAutoJump>
            <div></div>
        </QOpenApp>
    </div>
</template>
<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { apiInitWxConfig, apiExchangeInviteCode } from '@common/http/api';
import QOpenApp from '@qm-activity/common/components/q-open-app/index.vue';
import { copyToClipboard } from '@qm-activity/common/assets/ts/utils';
const storeCommon = useStoreCommon();
const openAppParams = computed(() => ({
    url: `https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/divide?full_screen=3&code=${storeCommon.urlParams.code || ''}&source=${storeCommon.urlParams.source || ''}`,
}));
</script>
<style lang="scss" scoped>
.page-share-land {
    background-color: #ffece1;
    min-height: 100vh;
}
.bottom-btn {
    width: 560px;
    height: 104px;
    background: url('@/assets/images/share-land/marathon_sharing_btn_open.png') no-repeat center/100% 100%;
    margin: 80px auto 0;
}
</style>
